/**
 * Quyền ở màn Module của cổng tenant (ADR-0104), suy từ ba mã `core:module:*`. Luật thuần để test bằng `node:test`;
 * module-registry là chốt chặn thật và kiểm cùng luật.
 */
import { QUYEN_MODULE } from '../constants.ts';

export interface QuyenManModule {
  /** Tab "Module đã duyệt". Quyền cài gồm cả quyền xem: không thấy danh sách thì không cài được gì. */
  xem: boolean;
  /** Nút "Nộp gói" và tab "Gói tôi đã nộp". */
  nop: boolean;
  /** Mục "Cài module" trong menu thao tác. */
  cai: boolean;
}

export function quyenManModule(co: (ma: string) => boolean): QuyenManModule {
  const cai = co(QUYEN_MODULE.cai);
  return { xem: cai || co(QUYEN_MODULE.xem), nop: co(QUYEN_MODULE.nop), cai };
}

/** Có ít nhất một việc làm được ở màn: dùng để hiện mục "Danh sách module" trên thanh điều hướng. */
export const vaoDuocManModule = (q: QuyenManModule): boolean => q.xem || q.nop;
